export const SCANNER_VOLUME_KEY = 'scannerSoundVolume';
export const SCANNER_VOLUME_MIN = 1;
export const SCANNER_VOLUME_MAX = 30;

const clampVolumeMultiplier = (value) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return SCANNER_VOLUME_MIN;
    return Math.min(SCANNER_VOLUME_MAX, Math.max(SCANNER_VOLUME_MIN, numeric));
};

export const getScannerVolumeMultiplier = () => {
    try {
        return clampVolumeMultiplier(localStorage.getItem(SCANNER_VOLUME_KEY));
    } catch {
        return SCANNER_VOLUME_MIN;
    }
};

export const setScannerVolumeMultiplier = (value) => {
    const next = clampVolumeMultiplier(value);
    try {
        localStorage.setItem(SCANNER_VOLUME_KEY, String(next));
    } catch {
        // Настройка останется только в текущей сессии.
    }
    return next;
};
